/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  function openSpectraWelcomeOffer(event) {
    var link = event.target.closest('a[href*="#newsletter-popup"]');
    if (!link) return;

    var popup = document.querySelector('.NewsletterPopup[data-section-type="newsletter-popup"]');
    if (!popup) return;

    event.preventDefault();
    popup.setAttribute('aria-hidden', 'false');

    try {
      window.localStorage.setItem('themePopup', 'true');
    } catch (error) {
      // The offer should still open when browser storage is unavailable.
    }

    var firstField = popup.querySelector('input[name="contact[first_name]"]');
    if (firstField) {
      window.setTimeout(function () {
        firstField.focus();
      }, 250);
    }
  }

  document.addEventListener('click', openSpectraWelcomeOffer);

  document.addEventListener('DOMContentLoaded', function () {
    var parameters = new URLSearchParams(window.location.search);

    if (window.location.hash === '#newsletter-popup' || parameters.get('welcome') === '1') {
      var popup = document.querySelector('.NewsletterPopup[data-section-type="newsletter-popup"]');
      if (popup) popup.setAttribute('aria-hidden', 'false');
    }
  });

  function numberValue(input) {
    return Math.max(0, parseFloat(input && input.value) || 0);
  }

  function formatArea(value) {
    return value.toFixed(2);
  }

  function initTileCalculator(calculator) {
    if (calculator.dataset.initialized === 'true') return;
    calculator.dataset.initialized = 'true';

    var coverage = parseFloat(calculator.dataset.boxCoverage) || 1.44;
    var toggle = calculator.querySelector('.SpectraTileCalculator__Toggle');
    var panel = calculator.querySelector('.SpectraTileCalculator__Panel');
    var toggleIcon = calculator.querySelector('.SpectraTileCalculator__ToggleIcon');
    var rooms = calculator.querySelector('[data-calculator-rooms]');
    var addRoom = calculator.querySelector('[data-add-calculator-room]');
    var waste = calculator.querySelector('[data-calculator-waste]');
    var apply = calculator.querySelector('[data-apply-calculation]');
    var areaInput = calculator.querySelector('[data-required-area]');
    var quantityInput = calculator.querySelector('[data-box-quantity]');
    var mode = 'floor';
    var result = { area: 0, boxes: 0, supplied: 0 };

    function setText(selector, value) {
      var element = calculator.querySelector(selector);
      if (element) element.textContent = value;
    }

    function syncOrderQuantity() {
      var requestedArea = Math.max(0.01, numberValue(areaInput));
      var boxes = Math.max(1, Math.ceil((requestedArea - 0.000001) / coverage));
      var supplied = boxes * coverage;

      quantityInput.value = boxes;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      setText('[data-order-boxes]', boxes);
      setText('[data-order-box-label]', boxes === 1 ? 'box' : 'boxes');
      setText('[data-order-supplied]', formatArea(supplied));
    }

    function calculate() {
      var area = 0;

      rooms.querySelectorAll('[data-calculator-room]').forEach(function (room) {
        var length = numberValue(room.querySelector('[data-room-length]'));
        var width = numberValue(room.querySelector('[data-room-width]'));
        var height = numberValue(room.querySelector('[data-room-height]'));

        if (mode === 'walls') {
          area += 2 * (length + width) * height;
        } else {
          area += length * width;
        }
      });

      var wasteRate = numberValue(waste) / 100;
      var areaWithWaste = area * (1 + wasteRate);
      var boxes = areaWithWaste > 0 ? Math.ceil((areaWithWaste - 0.000001) / coverage) : 0;
      var supplied = boxes * coverage;
      result = { area: areaWithWaste, boxes: boxes, supplied: supplied };

      setText('[data-calculated-area]', formatArea(areaWithWaste));
      setText('[data-calculated-boxes]', boxes);
      setText('[data-calculated-supplied]', formatArea(supplied));
      apply.disabled = boxes === 0;
    }

    function updateRoomLabels() {
      rooms.querySelectorAll('[data-calculator-room]').forEach(function (room, index) {
        room.querySelector('legend').textContent = 'Room ' + (index + 1);
      });
    }

    toggle.addEventListener('click', function () {
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      toggleIcon.textContent = willOpen ? '−' : '+';
    });

    calculator.querySelectorAll('[data-calculator-mode]').forEach(function (button) {
      button.addEventListener('click', function () {
        mode = button.dataset.calculatorMode;
        calculator.querySelectorAll('[data-calculator-mode]').forEach(function (tab) {
          var selected = tab === button;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        rooms.querySelectorAll('.SpectraTileCalculator__Height').forEach(function (field) {
          field.hidden = mode !== 'walls';
        });
        calculate();
      });
    });

    addRoom.addEventListener('click', function () {
      var newRoom = rooms.querySelector('[data-calculator-room]').cloneNode(true);
      newRoom.querySelectorAll('input').forEach(function (input) { input.value = ''; });
      newRoom.querySelector('.SpectraTileCalculator__Height').hidden = mode !== 'walls';
      rooms.appendChild(newRoom);
      updateRoomLabels();
      calculate();
    });

    rooms.addEventListener('input', calculate);
    waste.addEventListener('change', calculate);
    areaInput.addEventListener('input', syncOrderQuantity);
    areaInput.addEventListener('change', syncOrderQuantity);

    apply.addEventListener('click', function () {
      areaInput.value = formatArea(result.area);
      syncOrderQuantity();
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggleIcon.textContent = '+';
      areaInput.focus();
    });

    calculate();
    syncOrderQuantity();
  }

  function initAllTileCalculators(root) {
    (root || document).querySelectorAll('.SpectraTileCalculator').forEach(initTileCalculator);
  }

  function initLarsenCalculator(calculator) {
    if (calculator.dataset.initialized === 'true') return;
    calculator.dataset.initialized = 'true';

    var kind = calculator.dataset.calculatorKind;
    var toggle = calculator.querySelector('.SpectraLarsenCalculator__Toggle');
    var panel = calculator.querySelector('.SpectraLarsenCalculator__Panel');
    var icon = calculator.querySelector('.SpectraLarsenCalculator__ToggleIcon');
    var resultElement = calculator.querySelector('[data-larsen-result]');
    var detailElement = calculator.querySelector('[data-larsen-detail]');
    var apply = calculator.querySelector('[data-larsen-apply]');
    var quantity = calculator.querySelector('[data-larsen-quantity]');
    var recommended = 0;

    function value(selector) {
      return numberValue(calculator.querySelector(selector));
    }

    function calculate() {
      var detail = 'Enter your measurements to calculate.';

      if (kind === 'adhesive') {
        var area = value('[data-larsen-area]');
        var allowance = value('[data-larsen-waste]') / 100;
        recommended = area > 0 ? Math.ceil((area * (1 + allowance)) / 3) : 0;
        if (recommended) {
          detail = 'Covers up to ' + (recommended * 3).toFixed(0) + 'm² using our conservative 3m²-per-bag ordering allowance.';
        }
      } else if (kind === 'grout') {
        var groutArea = value('[data-larsen-area]');
        var tileLength = value('[data-tile-length]');
        var tileWidth = value('[data-tile-width]');
        var tileDepth = value('[data-tile-depth]');
        var jointWidth = value('[data-joint-width]');
        var kilograms = 0;

        if (groutArea && tileLength && tileWidth && tileDepth && jointWidth) {
          kilograms = groutArea * ((tileLength + tileWidth) / (tileLength * tileWidth)) * tileDepth * jointWidth * 1.6 * 1.10;
        }
        recommended = kilograms > 0 ? Math.ceil(kilograms / 3) : 0;
        if (recommended) {
          detail = 'Estimated use: ' + kilograms.toFixed(2) + 'kg including a 10% allowance. Supplied in full 3kg packs.';
        }
      } else if (kind === 'silicone') {
        var jointLength = value('[data-joint-length]');
        var width = value('[data-joint-width]');
        var depth = value('[data-joint-depth]');
        var millilitres = jointLength * width * depth;
        recommended = millilitres > 0 ? Math.ceil((millilitres * 1.10) / 300) : 0;
        if (recommended) {
          var metresPerCartridge = 300 / (width * depth);
          detail = 'Approx. ' + metresPerCartridge.toFixed(1) + ' linear metres per cartridge at this bead size before the application allowance.';
        }
      }

      resultElement.textContent = recommended;
      detailElement.textContent = detail;
      apply.disabled = recommended === 0;
    }

    toggle.addEventListener('click', function () {
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      icon.textContent = willOpen ? '−' : '+';
    });

    panel.addEventListener('input', calculate);
    panel.addEventListener('change', calculate);
    apply.addEventListener('click', function () {
      quantity.value = Math.max(1, recommended);
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      icon.textContent = '+';
      quantity.focus();
    });

    calculate();
  }

  function initAllLarsenCalculators(root) {
    (root || document).querySelectorAll('[data-larsen-calculator]').forEach(initLarsenCalculator);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllTileCalculators(document);
    initAllLarsenCalculators(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllTileCalculators(event.target);
    initAllLarsenCalculators(event.target);
  });

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('[data-spectra-selected-variant]').forEach(function (element) {
      element.textContent = variant.title;
    });
  });

  document.addEventListener('click', function (event) {
    var stickyButton = event.target.closest('[data-sticky-add-to-cart]');
    if (!stickyButton) return;

    var productForm = stickyButton.closest('.ProductForm');
    var addToCartButton = productForm && productForm.querySelector('[data-action="add-to-cart"]');
    if (addToCartButton && !addToCartButton.disabled) addToCartButton.click();
  });

  function initClearanceFilters(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-clearance-filter]').forEach(function (filter) {
      if (filter.dataset.initialized === 'true') return;
      filter.dataset.initialized = 'true';

      var grid = document.querySelector('[data-clearance-grid]');
      var empty = document.querySelector('[data-clearance-empty]');
      if (!grid) return;

      filter.addEventListener('click', function (event) {
        var button = event.target.closest('[data-clearance-filter-value]');
        if (!button) return;
        var value = button.dataset.clearanceFilterValue;
        var visible = 0;

        filter.querySelectorAll('button').forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });

        grid.querySelectorAll('[data-clearance-card]').forEach(function (card) {
          var show = value === 'all' || card.dataset.clearanceTerms.indexOf(value) !== -1;
          card.hidden = !show;
          if (show) visible += 1;
        });

        if (empty) empty.hidden = visible !== 0;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initClearanceFilters(document); });
  document.addEventListener('shopify:section:load', function (event) { initClearanceFilters(event.target); });

  function pushSpectraEvent(name, details) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name, page_path: window.location.pathname }, details || {}));
  }

  function normalizePostcode(value) {
    return (value || '').toUpperCase().replace(/\s+/g, ' ').trim();
  }

  function initDeliveryCheckers(root) {
    (root || document).querySelectorAll('[data-spectra-delivery-checker]').forEach(function (checker) {
      if (checker.dataset.initialized === 'true') return;
      checker.dataset.initialized = 'true';

      var input = checker.querySelector('[data-spectra-postcode]');
      var button = checker.querySelector('[data-spectra-check-delivery]');
      var form = checker.querySelector('[data-spectra-delivery-form]');
      var result = checker.querySelector('[data-spectra-delivery-result]');
      var remotePrefixes = /^(AB3[1-8]|AB4[1-5]|AB5[1-6]|FK1[7-9]|FK2[0-1]|IV|KW|PA2[0-9]|PA3[0-9]|PA4[0-9]|PA6[0-9]|PA7[0-8]|PH1[5-9]|PH2[0-9]|PH3[0-9]|PH4[0-4]|HS|ZE|IM|GY|JE|BT)/;

      function check() {
        var postcode = normalizePostcode(input.value);
        var valid = /^[A-Z]{1,2}[0-9][A-Z0-9]?\s?[0-9][A-Z]{2}$/.test(postcode);
        result.hidden = false;
        result.classList.remove('is-confirmation');

        if (!valid) {
          result.innerHTML = '<strong>Please enter a full UK postcode.</strong> For example: M1 1AA.';
          result.classList.add('is-confirmation');
          return;
        }

        if (remotePrefixes.test(postcode.replace(/\s/g, ''))) {
          result.innerHTML = '<strong>Please confirm this postcode with us before ordering.</strong> Remote, island and Northern Ireland destinations may need a tailored delivery quote.';
          result.classList.add('is-confirmation');
        } else {
          result.innerHTML = '<strong>Standard pallet-delivery pricing appears to apply.</strong> £59 kerbside pallet delivery, or free when the basket exceeds £449. Final availability is confirmed at checkout.';
        }

        pushSpectraEvent('spectra_delivery_check', { postcode_area: postcode.split(/[0-9]/)[0], requires_confirmation: remotePrefixes.test(postcode.replace(/\s/g, '')) });
      }

      button.addEventListener('click', check);
      button.addEventListener('pointerup', check);
      if (form) form.addEventListener('submit', function (event) {
        event.preventDefault();
        check();
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          check();
        }
      });
      input.addEventListener('input', function () {
        var postcode = normalizePostcode(input.value);
        if (/^[A-Z]{1,2}[0-9][A-Z0-9]?\s?[0-9][A-Z]{2}$/.test(postcode)) check();
      });
    });
  }

  function initSpectraConversionTools() {
    initDeliveryCheckers(document);

    var revealTargets = document.querySelectorAll('.sp-head, .sp-category, .sp-product, .sp-price-story__grid, .sp-google-reviews__head, .sp-review-card, .sp-buying-step, .sp-split, .sp-project, .sp-proof__grid, .sp-showroom__grid, .sp-concierge__grid, .sp-stock-card, .sp-intent-card, .sp-intent-help, .sp-complete-project__card');
    revealTargets.forEach(function (element, index) {
      element.classList.add('sp-reveal');
      element.classList.add('sp-reveal--delay-' + ((index % 4) || 1));
    });

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var revealObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
      revealTargets.forEach(function (element) { revealObserver.observe(element); });
    } else {
      revealTargets.forEach(function (element) { element.classList.add('is-visible'); });
    }

    if (window.theme && window.theme.pageType === 'product') {
      var productTitle = document.querySelector('.ProductMeta__Title');
      pushSpectraEvent('spectra_view_item', { item_name: productTitle ? productTitle.textContent.trim() : document.title });
    }
  }

  function initSpectraShoppingTools() {
    var root = document.querySelector('[data-spectra-shopping-tools]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    var storageKey = 'spectra-saved-products';
    var itemsRoot = root.querySelector('[data-spectra-tools-items]');
    var empty = root.querySelector('[data-spectra-tools-empty]');
    var count = root.querySelector('[data-spectra-tools-count]');
    var toggle = root.querySelector('[data-spectra-tools-toggle]');

    function readItems() {
      try { return JSON.parse(window.localStorage.getItem(storageKey) || '[]'); } catch (error) { return []; }
    }

    function writeItems(items) {
      window.localStorage.setItem(storageKey, JSON.stringify(items.slice(0, 4)));
      render();
    }

    function render() {
      var items = readItems();
      count.textContent = items.length;
      root.hidden = items.length === 0;
      empty.hidden = items.length !== 0;
      itemsRoot.innerHTML = items.map(function (item) {
        return '<article class="SpectraShoppingTools__Item"><img src="' + item.image + '" alt=""><a href="' + item.url + '"><strong>' + item.title + '</strong><span>' + item.price + '</span></a><button type="button" data-spectra-remove-product="' + item.id + '" aria-label="Remove ' + item.title + '">×</button></article>';
      }).join('');
      document.querySelectorAll('[data-spectra-save-product],[data-spectra-compare-product]').forEach(function (button) {
        var active = items.some(function (item) { return item.id === button.dataset.productId; });
        button.classList.toggle('is-active', active);
      });
    }

    function setOpen(open) {
      root.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.querySelector('.SpectraShoppingTools__Panel').setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-spectra-save-product],[data-spectra-compare-product]');
      if (button) {
        event.preventDefault();
        var items = readItems();
        var existing = items.findIndex(function (item) { return item.id === button.dataset.productId; });
        if (existing >= 0) items.splice(existing, 1);
        else if (items.length < 4) items.push({ id: button.dataset.productId, title: button.dataset.productTitle, url: button.dataset.productUrl, image: button.dataset.productImage, price: button.dataset.productPrice });
        writeItems(items);
        setOpen(items.length > 0);
        pushSpectraEvent('spectra_shortlist', { item_name: button.dataset.productTitle, saved: existing < 0 });
      }
      var remove = event.target.closest('[data-spectra-remove-product]');
      if (remove) writeItems(readItems().filter(function (item) { return item.id !== remove.dataset.spectraRemoveProduct; }));
    });

    toggle.addEventListener('click', function () { setOpen(!root.classList.contains('is-open')); });
    root.querySelector('[data-spectra-tools-close]').addEventListener('click', function () { setOpen(false); });
    root.querySelector('[data-spectra-tools-clear]').addEventListener('click', function () { writeItems([]); setOpen(false); });
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSpectraConversionTools(); initSpectraShoppingTools(); });
  } else {
    initSpectraConversionTools();
    initSpectraShoppingTools();
  }
  document.addEventListener('shopify:section:load', function (event) { initDeliveryCheckers(event.target); });

  document.addEventListener('product:added', function (event) {
    var variant = event.detail && event.detail.variant;
    pushSpectraEvent('spectra_add_to_cart', {
      item_name: variant && (variant.public_title || variant.name),
      item_id: variant && variant.id,
      quantity: event.detail && event.detail.quantity
    });
  });

  document.addEventListener('click', function (event) {
    var whatsapp = event.target.closest('[data-spectra-whatsapp]');
    if (whatsapp) pushSpectraEvent('spectra_whatsapp_click', { placement: whatsapp.dataset.spectraWhatsapp || 'unknown' });

    var checkout = event.target.closest('button[name="checkout"], a[href*="/checkout"]');
    if (checkout) pushSpectraEvent('spectra_begin_checkout');

    var calculator = event.target.closest('[data-apply-calculation]');
    if (calculator) pushSpectraEvent('spectra_quantity_calculated');
  });
})();
